var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .MenuDevice_a {\n                fill: #ff0d0d;\n                opacity: 0;\n            }\n\n            .MenuDevice_b {\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -447)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "MenuDevice_a",
    width: 24,
    height: 24,
    transform: "translate(23 447)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-454 -339.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M594.13,1094.569h-1.287a.644.644,0,1,0,0,1.287h1.287a.644.644,0,1,0,0-1.287Z",
    transform: "translate(-111.182 -296.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M594.13,1299.37h-1.287a.644.644,0,1,0,0,1.287h1.287a.644.644,0,1,0,0-1.287Z",
    transform: "translate(-111.182 -494.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M766.326,1299.37h-7.08a.644.644,0,0,0,0,1.287h7.08a.644.644,0,1,0,0-1.287Z",
    transform: "translate(-268.544 -494.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M594.13,889.768h-1.287a.644.644,0,0,0,0,1.287h1.287a.644.644,0,0,0,0-1.287Z",
    transform: "translate(-111.182 -98.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M766.326,889.768h-7.08a.644.644,0,0,0,0,1.287h7.08a.644.644,0,0,0,0-1.287Z",
    transform: "translate(-268.544 -98.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M766.326,1094.569h-7.08a.644.644,0,0,0,0,1.287h7.08a.644.644,0,0,0,0-1.287Z",
    transform: "translate(-268.544 -296.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MenuDevice_b",
    d: "M498.428,787.37H479.571A2.571,2.571,0,0,0,477,789.941v17.143a2.571,2.571,0,0,0,2.571,2.571h18.857A2.572,2.572,0,0,0,501,807.084V789.941A2.572,2.572,0,0,0,498.428,787.37Zm.857,19.714a.857.857,0,0,1-.857.857H479.571a.857.857,0,0,1-.857-.857V802.8h18a.857.857,0,0,0,0-1.714h-18v-5.143h18a.857.857,0,0,0,0-1.714h-18v-4.286a.857.857,0,0,1,.857-.857h18.857a.857.857,0,0,1,.857.857Z",
    transform: "translate(0 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDevice);
export default __webpack_public_path__ + "static/media/MenuDevice.f68d98b89d945f16c5b0d4e1d8b01ecd.svg";
export { ForwardRef as ReactComponent };